import api from "./api";

export interface Trainer {
  id: number;
  name: string;
  qualification: string;
  experience: string;
  description: string;
  photoUrl?: string | null;
  instagramUrl?: string | null;
  tiktokUrl?: string | null;
}

export const getTrainers = async (): Promise<Trainer[]> => {
  try {
    const response = await api.get<Trainer[]>("/trainers");
    return response.data;
  } catch (error) {
    console.error("Error fetching trainers:", error);
    throw error;
  }
};

export const getTrainer = async (id: number): Promise<Trainer> => {
  try {
    const response = await api.get<Trainer>(`/trainers/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching trainer with id=${id}:`, error);
    throw error;
  }
};

export const createTrainer = async (data: FormData): Promise<Trainer> => {
  try {
    const response = await api.post<Trainer>("/trainers", data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating trainer:", error);
    throw error;
  }
};

export const updateTrainer = async (
  id: number,
  data: FormData
): Promise<Trainer> => {
  try {
    const response = await api.put<Trainer>(`/trainers/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error(`Error updating trainer with id=${id}:`, error);
    throw error;
  }
};

export const deleteTrainer = async (id: number): Promise<void> => {
  try {
    const response = await api.delete(`/trainers/${id}`);
    if (response.status !== 200) {
      throw new Error("Failed to delete trainer");
    }
  } catch (error) {
    console.error(`Error deleting trainer with id=${id}:`, error);
    throw error;
  }
};
